import { useState } from "react";
import GameCard from "@/components/game/GameCard";
import { CARD_RATIO } from "@/lib/artAssets";

// Response prompts: select the card first, then Confirm.
export default function ResponseCardPick({ player, cardKey, confirmLabel, declineLabel, onDecide, busy, testPrefix }) {
  const [picked, setPicked] = useState(false);
  // Response cards are held action cards (player.action_cards); older saves kept them in the hand.
  const card = (player?.action_cards || []).find((c) => c.key === cardKey) || player?.hand?.find((c) => c.key === cardKey);
  return (
    <div className="mt-5 flex flex-col items-center gap-4">
      {card && (
        <div style={{ width: 120, height: Math.round(120 * CARD_RATIO) }} data-testid={`${testPrefix}-card`}>
          <GameCard card={card} size="fit" selected={picked} onClick={() => setPicked((p) => !p)} testid={`${testPrefix}-card-btn`} />
        </div>
      )}
      <div className="text-xs text-[color:var(--ink-3)]" data-testid={`${testPrefix}-pick-hint`}>
        {picked ? "Card selected — press Confirm to play it." : "Click the card to select it."}
      </div>
      <div className="flex justify-center gap-3">
        <button data-testid={`${testPrefix}-play`} onClick={() => onDecide(true)} disabled={busy || !picked} className="btn-tactile btn-tactile--primary">
          {confirmLabel}
        </button>
        <button data-testid={`${testPrefix}-decline`} onClick={() => onDecide(false)} disabled={busy} className="btn-tactile">
          {declineLabel}
        </button>
      </div>
    </div>
  );
}
